module.exports = __webpack_public_path__ + "img/gammaWeb.7cda3a2f.png";